import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '@ninety/ui/web/environments';

import { AuthorizeIntegrationParams } from './_state/auth-models';

export interface AuthorizeIntegrationResponse {
  redirect_uri: string;
}

@Injectable({ providedIn: 'root' })
export class ConsentApiService {
  private http = inject(HttpClient);

  private readonly apiBasePath = environment.authApiOrigin;
  private readonly authV1Api = `${this.apiBasePath}/v1`;

  authorizeIntegration(
    authorizeIntegrationParams: AuthorizeIntegrationParams
  ): Observable<AuthorizeIntegrationResponse> {
    const url = `${this.authV1Api}/oauth2/authorize`;
    return this.http.post<AuthorizeIntegrationResponse>(url, authorizeIntegrationParams);
  }

  getCompanyDetails(clientId: string): Observable<{ name: string; logo_url: string | null }> {
    const url = `${this.authV1Api}/client-credentials/${clientId}/entity`;
    return this.http.get<{ name: string; logo_url: string | null }>(url);
  }
}
